// localStorage, not sessionStorage: this flag has to survive from the
// verify-OTP screen, through a manual sign-in, to the first Dashboard
// load — a separate step (and possibly a closed tab) away — unlike
// authFlowState's short-lived OTP timers. Scoped by email so a different
// account signing in on the same browser before this is consumed never
// picks up someone else's reminder.
const PENDING_CLAIM_GUIDANCE_KEY = "medsynciq_pending_claim_guidance";

export interface PendingClaimGuidance {
  email: string;
  creatorName: string | null;
}

export function savePendingClaimGuidance(guidance: PendingClaimGuidance) {
  localStorage.setItem(PENDING_CLAIM_GUIDANCE_KEY, JSON.stringify(guidance));
}

/** Returns the pending guidance only if it belongs to this exact email — never leaks across accounts. */
export function getPendingClaimGuidance(email: string): PendingClaimGuidance | null {
  const raw = localStorage.getItem(PENDING_CLAIM_GUIDANCE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as PendingClaimGuidance;
    return parsed.email === email ? parsed : null;
  } catch {
    return null;
  }
}

export function clearPendingClaimGuidance() {
  localStorage.removeItem(PENDING_CLAIM_GUIDANCE_KEY);
}
